module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_9016.c6859f40.png";